import PropTypes from 'prop-types';
import getPropSelector from './getPropSelector';
const viewPropTypes = {
  pointerEvents: PropTypes.oneOf(['all', 'none', 'box-only', 'box-none']),
  onLayout: PropTypes.func,
  nativeID: PropTypes.string,
  testID: PropTypes.string,
  dataSet: PropTypes.object
};
export default {
  /**
   * Subset of `View` proptypes that could conceivably be needed on any component
   * that renders a single View.
   */
  types: viewPropTypes,
  /**
   * Filters a props object, returning only cross-platform View props that are potentially
   * relevant to any basic layout component that renders one View.
   */
  select: getPropSelector(viewPropTypes)
};